interface Props {
  children: React.ReactNode;
}

export default function PublicationsList({ children }: Props) {
  return <ul className="grid w-full grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3">{children}</ul>;
}
